
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import OverlayDropZone from './OverlayDropZone';
import '../stylesheets/overlay.scss';
import OverlayConfig from './OverlayConfig.json';
import { isAlive } from 'mobx-state-tree';

const HIDDEN = 'hidden';

/**
 * The Overlay View
 */

class OverlayView extends Component {

	render(){
		const { overlayModel, overlayParentNode } = this.props;
		if (!overlayModel || !isAlive(overlayModel)) {
			// unable to render the view if the model is dead
			return null;
		}
		// NOTE: This ensures the OverlayView properly reacts to the model change
		void(overlayModel.modelVer);
		const OVERLAY_STATES = overlayModel.OVERLAY_STATE;
		const currentState = overlayModel.overlayState;
		if (currentState) {
			let className = 'overlayView';
			let toShow = true;
			if (currentState === OVERLAY_STATES.HIDE) {
				toShow = false;
			} else if (currentState === OVERLAY_STATES.SMALL){
				className += ' smallView';
			}
			if (toShow) {
				this._removeHidden(overlayParentNode);
			} else {
				this._setHidden(overlayParentNode);
			}
			const slotsMap = this._buildSlotsMap();
			if (Object.keys(slotsMap).length) {
				return (
					<div className={className}>
						{this._renderContainers(slotsMap)}
					</div>
				);
			}
		}
		return null;
	}
	// Hide the whole dropZoneOverlay element to not interfere with selection in widget
	_setHidden(node) {
		const classList = node.classList;
		if (classList && !classList.contains(HIDDEN)) {
			classList.add(HIDDEN);
		}
	}

	_removeHidden(node) {
		const classList = node.classList;
		if (classList && classList.contains(HIDDEN)) {
			classList.remove(HIDDEN);
		}
	}

	_buildSlotsMap(){
		const visualization = this.props.content.getFeature('Visualization');
		const visType = visualization.getType();
		const slots = visualization.getSlots();
		const slotsList = slots.getSlotList();
		const slotsMap = {};
		slotsList.map((slot) => {
			const slotId = slot.getDefinition().getId();
			let className = this._getDropZonePosition(visType, slotId);
			if(className){
				slotsMap[className] = slotsMap[className]? slotsMap[className] : [];
				slotsMap[className].push(slot);
			}
		});
		return slotsMap;
	}

	_renderDropZones(slots){
		if(slots){
			return slots.map((slot) => {
				const slotId = slot.getDefinition().getId();
				const dndManager = this.props.dashboard.getFeature('.DndManager');
				return (<OverlayDropZone
					key={slotId}
					slot={slot}
					slotDataItemHandler={this.props.overlayModel.getSlotDataItemHandler(slot, -1/*index in slot*/)}
					dashboard = {this.props.dashboard}
					dndManager={dndManager} >
				</OverlayDropZone>);
			});
		}
	}

	_renderContainers(slotsMap){
		return (<div className='overlayContainer'>
			{this._renderVerticalContainer(slotsMap, 'left')}
			<div className='overlayContainerMiddle'>
				{this._renderHorizontalContainer(slotsMap)}
				{this._renderHorizontalContainer(slotsMap, 'bottom')}
			</div>
			{this._renderVerticalContainer(slotsMap, 'right')}
		</div>);
	}

	_renderHorizontalContainer(slotsMap, position = 'top') {
		const sectionClassName = 'overlayContainer_' + position;
		if (slotsMap[position + '_single'] || slotsMap[position + '_multiple']) {
			return (<div className= {sectionClassName} >
				{slotsMap[position + '_multiple']
					&& <div className='overlayContainerMultiple'>
						{this._renderDropZones(slotsMap[position + '_multiple'])}
					</div>}
				{slotsMap[position + '_single']
					&& <div className='overlayContainerSingle'>
						{this._renderDropZones(slotsMap[position + '_single'])}
					</div>}
			</div>);
		}
	}

	_renderVerticalContainer(slotsMap, position = 'left') {
		const sectionClassName = 'section_' + position;
		const className = 'overlayContainer_' + position;
		if (slotsMap[position]) {
			return (
				<div className={sectionClassName}>
					<div className={className}>
						{this._renderDropZones(slotsMap[position])}
					</div>
				</div>);
		}
	}

	_getDropZonePosition(visType, slotId){
		const SLOTS_ID_POSITION_MAP = OverlayConfig;
		let dropZonePosition;
		if(SLOTS_ID_POSITION_MAP[visType]){
			Object.keys(SLOTS_ID_POSITION_MAP[visType]).forEach(function (position) {
				if(SLOTS_ID_POSITION_MAP[visType][position].includes(slotId)){
					dropZonePosition = position;
				}
			});
		}
		return dropZonePosition;
	}
}

OverlayView.propTypes = {
	content: PropTypes.object.isRequired,
	dashboard: PropTypes.object.isRequired,
	overlayModel: PropTypes.object.isRequired,
	overlayParentNode: PropTypes.object.isRequired
};

export default observer(OverlayView);


// WEBPACK FOOTER //
// ./src/js/OverlayView.js